<template>
  <div class="header_col">
    <div class="hco_col">
      <div class="header-l"><a href="/" class="logo-lw w-inline-block"><img
          src="https://cdn.prod.website-files.com/5e975a649e6ac66451307402/66a8fd03578b1593429dac04_ti_logo.svg"
          loading="lazy" alt="" class="logo"></a></div>
      <div class="header-r">
        <div class="header-i">
          <div class="tp_trv"><img
              src="https://cdn.prod.website-files.com/5e975a649e6ac66451307402/67d27072bacc6b2de894bf10_ecross.png"
              loading="lazy" alt="" class="image">
            <div>
              <div class="text-block">{{ $t('contact.assistance.title') }}<br><a :href="'tel:' + $t('contact.assistance.tel')">{{ $t('contact.assistance.tel') }}</a></div>
              <div class="rws">
                <div class="ico mr"></div>
                <div><a :href="'mailto:' + $t('contact.email')">{{ $t('contact.email') }}</a><br></div>
              </div>
              <div class="rws">
                <div class="ico mr"></div>
                <div><a :href="'tel:' + $t('contact.tel')">{{ $t('contact.tel') }}</a><br></div>
              </div>
            </div>
          </div>
        </div>
        <a href="#" class="ham w-inline-block">
          <div class="hm hm1"></div>
          <div class="hm hm2"></div>
          <div class="hm hm3"></div>
        </a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderPartSisa",
  props: {
    product: String
  }

}
</script>

<style>
@font-face {
  font-family: 'Fa Light 300';
  font-style: normal;
  font-weight: 300;
  font-display: block;
  src: url('https://cdn.prod.website-files.com/5e975a649e6ac66451307402/6475ec698ecc8ad34da25038_fa-light-300.woff') format('woff');
}

.ico {
  font-family: "Fa Light 300", sans-serif;
}
</style>

<style scoped>
.text-block a,
.rws a {
  text-decoration: none;
  color: inherit;
}

.text-block a:hover,
.rws a:hover {
  text-decoration: underline;
}


</style>

